import type { DocPageContent } from '../docs-content'

const page = {
  order: 7,
  slug: 'editing-tools',
  title: 'Herramientas de edición',
  description:
    'Selección, cuchilla, recorte, deslizamiento (slip), desplazamiento (slide), estiramiento de velocidad, y los comportamientos de recorte por ondulación y rodante.',
  category: 'Edición principal',
  related: ['timeline', 'keyboard-shortcuts', 'properties'],
  sections: [
    {
      title: 'Las herramientas principales',
      blocks: [
        {
          kind: 'table',
          headers: ['Herramienta', 'Tecla', 'Uso'],
          rows: [
            ['Selección', '`V`', 'Seleccionar, mover y organizar clips.'],
            ['Editar recorte', '`T`', 'Arrastra el borde de un clip para cambiar dónde empieza o termina.'],
            ['Cuchilla', '`C`', 'Corta un clip donde hagas clic.'],
            ['Estiramiento de velocidad', '`R`', 'Cambia la duración modificando la velocidad de reproducción.'],
            ['Deslizamiento (slip)', '`Y`', 'Cambia los fotogramas de origen dentro de un clip sin moverlo.'],
            ['Desplazamiento (slide)', '`U`', 'Mueve un clip mientras ajusta los cortes vecinos.'],
          ],
        },
      ],
    },
    {
      title: 'Comportamientos de recorte',
      blocks: [
        {
          kind: 'list',
          items: [
            'Un recorte por **ondulación (ripple)** cambia una edición y desplaza todo el material posterior, por lo que la duración total cambia.',
            'Un recorte **rodante (rolling)** mueve el corte entre dos clips vecinos, sin cambiar la duración total.',
            'Una edición de **deslizamiento (slip)** cambia qué fotogramas de origen aparecen dentro de un clip sin mover el clip ni a sus vecinos.',
            'Una edición de **desplazamiento (slide)** mueve un clip a lo largo de la pista mientras ajusta automáticamente los cortes vecinos.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Ondulación y rodante son comportamientos de la herramienta **Editar recorte**, no herramientas independientes con su propio atajo.',
        },
      ],
    },
    {
      title: 'Mantener los clips sincronizados',
      blocks: [
        {
          kind: 'list',
          items: [
            'La **selección vinculada** mueve un clip de video y su audio juntos; actívala o desactívala con `Shift+L`.',
            'Vincula clips con `Ctrl+Alt+L` y desvincúlalos con `Alt+Shift+L` cuando una relación necesite cambiar.',
            'El **bloqueo de sincronización** en una pista mantiene el tiempo alineado durante ediciones de tipo ondulación.',
          ],
        },
      ],
    },
    {
      title: 'Ediciones estructurales',
      blocks: [
        {
          kind: 'list',
          items: [
            'Inserta un **fotograma congelado** en el cursor de reproducción con `Shift+F` para mantener un solo fotograma.',
            'Agrupa una serie de clips en un **clip compuesto** para reutilizar o simplificar una sección cargada, o ábrelo como pestaña de **secuencia** para editarlo como una línea de tiempo independiente.',
            'Usa el diálogo de **Diseño Bento** para organizar los clips visuales seleccionados en una cuadrícula estructurada.',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
